import type { AnalyticsEventPayload } from '@atlaskit/analytics-next';

import { filterCommonAttributes } from './analytics-helpers';
import type { commonAttributesType } from './types';

// When the ai answer loading dialog is initially shown to the user
export const onAIAnswerLoadingDialogShown: (
	props: commonAttributesType,
	isAnimated?: boolean,
) => AnalyticsEventPayload = (
	props: commonAttributesType,
	isAnimated?: boolean,
): AnalyticsEventPayload => {
	const { query, source } = props;
	return {
		action: 'shown',
		actionSubject: 'aiAnswerLoadingDialog',
		source: source,
		eventType: 'track',
		attributes: {
			...filterCommonAttributes(props),
			isAnimated,
		},
		nonPrivacySafeAttributes: {
			query,
		},
	};
};
